export default "__VITE_ASSET__DXeE$SkC__"